
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.565.405a1.35 1.35 0 00-.96-.405 1.336 1.336 0 00-.96.405L6.573 10.623 2.341 6.322a1.38 1.38 0 00-.983-.393 1.367 1.367 0 00-.97.427A1.402 1.402 0 000 7.353a1.415 1.415 0 00.422.982l5.191 5.26a1.353 1.353 0 00.96.405 1.337 1.337 0 00.96-.405L18.565 2.419A1.37 1.37 0 0019 1.412a1.385 1.385 0 00-.435-1.007z"}})])
          )
        }
      }
    